<template lang="pug">
  div.banner
    div.container
      h3 {{ gettext('Become a Bixter trainee') }}
      a(href="https://www.bixter.training" target="_blanc")
        div.main-btn.bg-red.col-white {{ gettext('Read more about our programs') }}
</template>

<script>
import { gettext } from './../../../../services/TranslateHandler'

export default {
  methods: {
    gettext: gettext
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 400px;
  background-image: url("../../../../assets/images/agricultural-trainee/head.jpg");
  background-position: center 35%;
  background-size: cover;
  display: flex;
  align-content: center;
  align-items: center;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    position: relative;
    z-index: 1;
  }
  .main-btn {
    white-space: nowrap;
    padding: 0 22px;
    width: auto;
  }
  h3 {
    font-size: 42px;
    font-weight: bold;
    text-align: center;
    color: white;
    margin-bottom: 10px;
    line-height: normal;
  }
}
@media screen and (max-width: 840px){
  .banner{
    .h3{
      font-size: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/parts/banner/index.vue